import { z } from 'zod';

const HTTP_URL_PROTOCOL_PATTERN = /^https?:\/\/.+/i;
const DOMAIN_NAME_PATTERN = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

export function isValidUrlHostname(hostname: string): boolean {
  return DOMAIN_NAME_PATTERN.test(hostname);
}

export function isValidHttpUrl(value: string): boolean {
  if (!HTTP_URL_PROTOCOL_PATTERN.test(value) || !z.string().url().safeParse(value).success) {
    return false;
  }

  try {
    const { hostname } = new URL(value);

    return isValidUrlHostname(hostname);
  } catch {
    return false;
  }
}

export function isValidOptionalHttpUrl(value: string | undefined): boolean {
  if (!value) {
    return true;
  }

  return isValidHttpUrl(value);
}

export function createOptionalHttpUrlFieldValidator() {
  return z
    .string()
    .refine((value) => isValidOptionalHttpUrl(value), { message: 'errorMessages.invalidUrl' })
    .optional();
}
